// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2lVwu","productName":"Table_productName__3hyIY"};